export default {
  props: [
    {
      attr: 'name',
      name: '校区名称',
      slot: 'name'
    },
    {
      attr: 'cuStomerType',
      name: '校区类型',
      slot: 'cuStomerType'
    },
    {
      attr: 'contactname',
      name: '联系人',
      slot: 'contactname'
    },
    {
      attr: 'contactphone',
      name: '联系电话',
      slot: 'contactphone'
    },
    {
      attr: 'adminemail',
      name: '管理员邮箱',
      slot: 'adminemail'
    },
    {
      attr: 'address',
      name: '校区地址',
      slot: 'address'
    },
    {
      attr: 'status',
      name: '校区状态',
      slot: 'status'
    },
    {
      attr: 'coursePackage',
      name: '课程包数量',
      slot: 'coursePackage'
    },
    {
      attr: 'bindCount',
      name: '剩余激活码数量',
      slot: 'bindCount'
    },
    {
      attr: 'readOnly',
      name: '查看权限',
      slot: 'readOnly'
    }
  ]
};
